import { render, staticRenderFns } from "./ingredientStared.vue?vue&type=template&id=91bdd7ec"
import script from "./ingredientStared.vue?vue&type=script&lang=js"
export * from "./ingredientStared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports